import { PlayerEnvironment } from './player_environment';
import { PlayerAhoyEvent } from './player_ahoy_event';
import VideoHelpers from './utils/video_helpers';
export default class HdcpBlocker {
  constructor({ tech, data, blocker } = {}) {
    this._tech = tech;
    this._data = data;
    this._blockerCountdown = 5 * 1000;
    this._started = false;
    this._blockerInterval = null;
    this._element = null;
    this._blocker = blocker;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  blockerCountdown() {
    return this._blockerCountdown;
  }

  started() {
    return this._started;
  }

  init() {
    this.setAhoyEventGlobalProperties();
    this.createHdcpBlocker();
    this.checkPlayability();
    this.onContentStart();
  }

  checkPlayability() {
    if (PlayerEnvironment.isMobileSite()) {
      this._blockerCountdown = 0;
      this.onContentBuffer();
    } else {
      this.onContentBuffer();
    }
  }

  onContentBuffer() {
    this.tech().one('bufferstart', () => {
      this.contentBufferHandler();
    });
  }

  contentBufferHandler() {
    if (this.started()) return;

    this._blockerInterval = setInterval(() => {
      this.removeInterval();
      this.showBlocker();
    }, this.blockerCountdown());
  }

  onContentStart() {
    this.tech().on('vp-start', () => {
      this._started = true;
      this.removeInterval();
    });
  }

  removeInterval() {
    clearInterval(this._blockerInterval);
    this._blockerInterval = null;
  }

  showBlocker() {
    this.tech().pause();
    this.tech().el().addClass('vjs-error');
    this._blocker.showMessage(this._element);
    this.sendEvent();
  }

  createHdcpBlocker() {
    const vod_player = document.querySelector('#' + this.data().playerId());
    if (vod_player)
      vod_player.classList.add(
        'video-js',
        'vjs-fluid',
        'vod-player-dimensions'
      );

    const lang = VideoHelpers.getLang();
    const message = this.blockerContentRevamp(lang);
    const supportLink = 'https://support.vidio.com/support/solutions/articles/43000642152-hdcp-information'
    let ctaButtons = [];
    ctaButtons.push(this._blocker.exploreVidioButton(message.cta))
    ctaButtons.push(this._blocker.withDirectLinkButton(message.additionalCta, supportLink, 'additionalWhiteCta-button'));
    this._element = this._blocker.renderBlocker2ButtonCta(message, 'hdcp', ctaButtons);
  }

  sendEvent() {
    PlayerAhoyEvent.sendBlocker(
      this.data().type().toLowerCase(),
      this.data().isPremier(),
      this.data().videoId(),
      'hdcp'
    );
  }

  blockerContentRevamp(lang) {
    const message = {
      id: {
        title: 'Konten nggak bisa diputar',
        subtitle:
          'Perangkatmu nggak mendukung HDCP. Gunakan perangkat lain atau cari hiburan lain.',
        cta: 'Jelajahi Vidio',
        additionalCta: 'Info Lengkap',
      },
      en: {
        title: "This content can't be played",
        subtitle:
          "Your device doesn’t support HDCP. Please use another device or browse other content.",
        cta: 'Explore Vidio',
        additionalCta: 'More Info',
      },
    };

    return message[lang];
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data().isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data().preview(),
      cdn: this.data().cdnName(),
      embed: this.data().embed() === 'true',
    };

    if (this.data().userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data().isVideo()) {
      if (this.data().filmId() != 0) {
        globalData.film_id = this.data().filmId();
      }

      if (this.data().seasonId() != 0) {
        globalData.season_id = this.data().seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
